import { createInjectionState } from '@vueuse/core';
import { reactive, ref } from 'vue';

export function useBlobHandlerDialog(defaultDownloadAction?: string) {
    const viewerUrl = ref<string | undefined>();
    const viewerText = ref<string | undefined>();
    const downloadAction = ref(defaultDownloadAction);
    const downloadParams = ref<unknown>();
    const downloadSubmit = ref(0);
    const callbacks: ((a: undefined) => void)[] = [];

    function viewBlobUrl(_viewerUrl: string) {
        return new Promise((resolve) => {
            callbacks.push(resolve);
            viewerUrl.value = _viewerUrl;
        });
    }
    function viewBlobText(_viewerText: string) {
        return new Promise((resolve) => {
            callbacks.push(resolve);
            viewerText.value = _viewerText;
        });
    }
    function downloadBlob(_downloadParams: unknown, _downloadAction?: string) {
        if(_downloadAction) {
            downloadAction.value = _downloadAction;
        }
        downloadParams.value = _downloadParams;
        downloadSubmit.value += 1;
    }
    function viewerClosed() {
        callbacks.pop()?.(undefined);
    }

    return reactive({
        viewerUrl,
        viewerText,
        viewerClosed,
        downloadAction,
        downloadParams,
        downloadSubmit,
        viewBlobUrl,
        viewBlobText,
        downloadBlob,
    });
}
export type BlobHandlerDialogProvider = ReturnType<typeof useBlobHandlerDialog>;

const [useProvideBlobHandlerDialog, _useGlobalBlobHandlerDialog] = createInjectionState(useBlobHandlerDialog);

export { useProvideBlobHandlerDialog };
export function useGlobalBlobHandlerDialog() {
    const handler = _useGlobalBlobHandlerDialog();
    if(!handler) {
        throw new Error('BlobHandlerDialog is not provided');
    }
    return handler;
}
